import { directApiInstance } from './httpClient';

/**
 * Business employees (samUserManagement, SAM-1297). The tenant Front Desk creates the person and the assignment to a
 * business of its tenant: database rows only, pending Security, with no sign-in, no gate zones and no app access.
 */
export interface BusinessPosition {
  key: string;
  label_en: string;
  label_es: string;
}

export interface CreateEmployeeRequest {
  first_name: string;
  last_name: string;
  phone: string;
  position_key: string;
  /** yyyy-mm-dd */
  valid_until: string;
  birthdate?: string;
  nationality?: string;
  id_type?: 'cedula' | 'passport' | 'driver_license';
  id_number?: string;
}

export const listBusinessPositions = (businessId: string) =>
  directApiInstance<{ positions: BusinessPosition[] }>({ url: `/businesses/${businessId}/positions`, method: 'GET' });

export const createBusinessEmployee = (businessId: string, body: CreateEmployeeRequest) =>
  directApiInstance<{ employee: { id: string; employee_id: string; security_status: string } }>({
    url: `/businesses/${businessId}/employees`,
    method: 'POST',
    data: body,
    // SAM-1323: the sheet reports a refused add itself (a duplicate is a 409); the generic toast would say it twice
    quietErrors: true,
  } as Parameters<typeof directApiInstance>[0]);

/** What a carnet request's detail reads of the person (GET /employees/{id}; the tenant Admin and Front Desk may). */
export interface EmployeeDetail {
  id: string;
  phone?: string | null;
  photo_url?: string | null;
  id_type?: string | null;
  /** Only the last 4 digits come back (masked). */
  id_number_masked?: string | null;
  assignments?: Array<{
    id: string;
    business_id: string;
    position?: { key: string; label_en?: string; label_es?: string } | null;
    valid_from?: string | null;
    valid_until?: string | null;
  }>;
}

export const getEmployee = async (employeeId: string) =>
  (await directApiInstance({
    url: `/employees/${encodeURIComponent(employeeId)}`,
    method: 'GET',
    // Summary view: no documents nor id_number, only what the carnet card shows.
    params: { view: 'summary' },
    // The request detail already shows what the payload has; a refusal here must not toast.
    quietErrors: true,
  } as Parameters<typeof directApiInstance>[0]) as unknown as { employee: EmployeeDetail }).employee;
